<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset>
    <div class="form-group fieldIsRequired">
      <label class="col-sm-3 control-label"> Refresh Token </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="merchantName"
          id="merchantNameEdit"
          [ngClass]="{
            'is-invalid':
              parentGroup.controls.refreshToken.invalid &&
              parentGroup.controls.refreshToken.touched
          }"
          formControlName="refreshToken"
        />
        <div
          class="formValidationMessage mt-1"
          role="alert"
          *ngIf="
            parentGroup.controls.refreshToken.invalid &&
            parentGroup.controls.refreshToken.touched
          "
        >
          <div class="mt-1">
            <div *ngIf="parentGroup.controls.refreshToken.errors?.required">
              Field is required.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
